export default __webpack_public_path__ + "static/media/global-app-ebrochure.f274788a.jpg";